/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ClientManagementFormComponent as ɵb} from './client-form/client-management-form.component';
export {ClientManagementComponent as ɵc} from './client-management.component';
export {declaration as ɵa} from './client-management.module';
export {ClientManagementRoutes as ɵd} from './client-management.routing';